import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { ITipoCargaSPE } from "../types/types";

interface Props {
  data?: ITipoCargaSPE;
  title: string;
  onClose: () => void;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID Tipo de Carga SPE
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_tipo_carga_SPE ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Tipo de Carga
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tipo_carga ?? '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data Modificação
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Usuário Responsável
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ?? '---'}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
